import { WorkInjuryAcceptedCoverageType } from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";

import { RequirementDefinitionWorkInjuryFormValues } from "../../../../types";
import { COVERAGE_TYPE_LABELS, WORKERS_COMP_BUNDLE_LABELS } from "./constants";
import { formatLimit } from "./formatLimit";

export const getWorkInjurySettings = (
  settings: Partial<RequirementDefinitionWorkInjuryFormValues>
): string[] => {
  const items: string[] = [];

  if (settings.coverageType) {
    const label =
      COVERAGE_TYPE_LABELS[settings.coverageType as string] ??
      String(settings.coverageType);
    items.push(`Coverage type: ${label}`);
  }

  if (
    settings.workersCompLimitMinimum &&
    settings.coverageType !==
      WorkInjuryAcceptedCoverageType.OccupationalAccident
  ) {
    const bundleLabel =
      WORKERS_COMP_BUNDLE_LABELS[settings.workersCompLimitMinimum as string] ??
      String(settings.workersCompLimitMinimum);
    items.push(`Employer's liability: ${bundleLabel}`);
  }

  if (
    settings.coverageType !== WorkInjuryAcceptedCoverageType.WorkersCompensation
  ) {
    if (settings.occAccidentMedicalMinimum) {
      items.push(
        `Medical coverage: ${formatLimit(settings.occAccidentMedicalMinimum)}`
      );
    }
    if (settings.occAccidentDeathMinimum) {
      items.push(
        `Death & dismemberment: ${formatLimit(settings.occAccidentDeathMinimum)}`
      );
    }
  }

  if (settings.acceptWingspanMasterPolicy !== undefined) {
    items.push(
      `Wingspan Master Policy: ${settings.acceptWingspanMasterPolicy ? "Accepted" : "Not accepted"}`
    );
  }

  return items;
};
